<template>
  <SidebarHeader
    :isLoading="isLoading"
    :titleHref="activeReisetermin ? '#/reisetermine/' + activeReisetermin.id : null"
    :kuerzel="activeReisetermin ? reisekuerzel : ''"
    :datum="startdatumFormatted"
    :ursprung="
      activeReisetermin?.ursprungsreiseterminId
        ? {
            id: activeReisetermin.ursprungsreiseterminId,
            kuerzel: activeReisetermin.ursprungsreisetermin?.reiseterminkuerzel,
          }
        : null
    "
    :ersatz="
      activeReisetermin?.ersatztermin
        ? {
            id: activeReisetermin.ersatztermin.id,
            kuerzel: activeReisetermin.ersatztermin.reiseterminkuerzel,
          }
        : null
    "
    @go-up="$emit('go-up')"
    @go-down="$emit('go-down')"
    @close="$emit('close')"
  >
    <template #badge>
      <ReiseterminStateBadge v-if="activeReisetermin" :state="activeReisetermin.state" />
    </template>
    <template #actions>
      <template v-if="activeReisetermin">
        <b-button
          class="btn btn-icon icon-button"
          size="sm"
          v-b-tooltip.hover.bottom
          title="Neu laden"
          :disabled="isLoading || !disableSpeichernButton"
          @click="$emit('reload')"
        >
          <RotateCcw :size="16" />
        </b-button>
        <b-button
          class="btn btn-icon icon-button"
          size="sm"
          v-b-tooltip.hover.bottom
          title="Reisestammdaten"
          :href="
            '#/reisen/' +
            activeReisetermin.reiseterminkuerzel?.substring(0, 6) +
            '/reisestammdaten?reiseterminAbreisedatum=' +
            activeReisetermin.abreisedatum.substring(0, 10)
          "
          target="_blank"
        >
          <Pencil :size="16" />
        </b-button>
        <b-dropdown
          id="sidebar-terminplanung-aktionen"
          v-if="zeigeAktionen"
          right
          no-caret
          size="sm"
          toggle-class="btn-icon icon-button"
          menu-class="aktionen-dropdown"
          :toggle-attrs="{ 'aria-label': 'Weitere Aktionen' }"
        >
          <template #button-content>
            <Ellipsis :size="16" />
          </template>
          <b-dropdown-item
            v-for="option in statuswechsel.statusOptionen"
            :key="option.value"
            size="sm"
            @click="$emit('status-wechseln', option)"
          >
            {{ option.label }}
          </b-dropdown-item>
          <b-dropdown-divider
            v-if="statuswechsel.statusOptionen.length && (zeigeVerschieben || statuswechsel.verwerfenErlaubt)"
          />
          <b-dropdown-item v-if="zeigeVerschieben" size="sm" @click="$emit('termin-verschieben')">
            Termin verschieben
          </b-dropdown-item>
          <b-dropdown-item v-if="statuswechsel.verwerfenErlaubt" size="sm" @click="$emit('termin-verwerfen')">
            Termin verwerfen
          </b-dropdown-item>
          <b-dropdown-divider v-if="zeigeTrennerVorLoeschen" />
          <b-dropdown-item
            v-if="zeigeLoeschen"
            size="sm"
            @click="$emit('reisetermin-loeschen')"
            variant="danger"
          >
            Reisetermin löschen
          </b-dropdown-item>
        </b-dropdown>
        <b-tooltip
          v-if="zeigeAktionen"
          target="sidebar-terminplanung-aktionen__BV_toggle_"
          triggers="hover"
          placement="bottom"
        >
          Weitere Aktionen
        </b-tooltip>
        <b-button
          class="btn btn-icon icon-button"
          size="sm"
          v-b-tooltip.hover.bottom
          title="Aufgabe erstellen"
          v-b-modal.modalAufgabeEdit
          @click="$emit('aufgabe-erstellen')"
        >
          <ListChecks :size="16" />
        </b-button>
        <b-button
          class="dialog-btn"
          size="sm"
          @click="$emit('save')"
          :variant="disableSpeichernButton ? 'secondary' : 'primary'"
          :disabled="disableSpeichernButton"
        >
          Speichern
        </b-button>
      </template>
    </template>
  </SidebarHeader>
</template>

<script>
import { Pencil, ListChecks, Ellipsis, RotateCcw } from 'lucide-vue';
import { getStatuswechselOptionen } from '@/core/produkte/reisetermine/reisetermin-statuswechsel';
import ReiseterminStateBadge from '@/components/produkte/reisetermine/reisetermin-state-badge.vue';
import SidebarHeader from '@/components/common/sidebar-section/sidebar-header.vue';

export default {
  name: 'SidebarTerminplanungHeader',
  components: { Pencil, ListChecks, Ellipsis, RotateCcw, ReiseterminStateBadge, SidebarHeader },
  props: {
    isLoading: { type: Boolean, default: false },
    activeReisetermin: { type: Object, default: null },
    reisekuerzel: { type: String, default: '' },
    startdatumFormatted: { type: String, default: '' },
    disableSpeichernButton: { type: Boolean, default: false },
  },
  computed: {
    statuswechsel() {
      return getStatuswechselOptionen(
        this.activeReisetermin?.state,
        this.activeReisetermin?.reiseterminSyncState
      );
    },
    zeigeVerschieben() {
      return this.activeReisetermin?.ersatztermin == null;
    },
    // Hart gelöscht werden dürfen nur Termine, die es in Blank noch nicht gibt
    zeigeLoeschen() {
      return this.activeReisetermin?.reiseterminSyncState === 'NotAvailableInBlank';
    },
    // Der Trenner steht nur, wenn über "Reisetermin löschen" tatsächlich Einträge stehen
    zeigeTrennerVorLoeschen() {
      return (
        this.zeigeLoeschen &&
        (this.statuswechsel.statusOptionen.length > 0 ||
          this.zeigeVerschieben ||
          this.statuswechsel.verwerfenErlaubt)
      );
    },
    zeigeAktionen() {
      return (
        this.statuswechsel.statusOptionen.length > 0 ||
        this.zeigeVerschieben ||
        this.statuswechsel.verwerfenErlaubt ||
        this.zeigeLoeschen
      );
    },
  },
};
</script>
